import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import './sidemenu.css';
import { useEffect, useRef, useState } from 'react';
import menuButton from '../../assets/icons/menu.png';
import toOpen from '../../assets/icons/toOpen.png';
import userIcon from '../../assets/icons/user.png'
import vehicleIcon from '../../assets/icons/vehicleActive.svg';
import vehicleInactive from '../../assets/icons/vehicleIact.svg';
import { Grid2, Typography } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import userInactive from '../../assets/icons/userInactive.png';
import fleetActive from '../../assets/icons/fleetAct.svg';
import fleetInactive from '../../assets/icons/fleetInact.svg';
import constants from '../../constant.js'
import dashboardIcon from '../../assets/icons/dashboardIcon.png';
import dashboardActive from '../../assets/icons/dashboardActive.png';
import settingsIcon from '../../assets/icons/settingscon.svg';
import settingsInactive from '../../assets/icons/settingsInactive.svg';
import customZoneAct from '../../assets/icons/customZoneAct.svg';
import customZoneInact from '../../assets/icons/customZoneInact.svg';
import geofenceAct from '../../assets/icons/geofenceAct.svg';
import geofence from '../../assets/icons/geofence.svg';
import homescreen from '../../assets/icons/homescreen.svg';
import homescreenAct from '../../assets/icons/homescreenAct.svg';
import analytics from '../../assets/icons/analytics.svg';
import analyticsAct from '../../assets/icons/analyticsAct.svg';
import corporate from '../../assets/icons/corporate.svg';
import corporateAct from '../../assets/icons/corporateAct.svg';
import surgePricing from '../../assets/icons/surgePricing.svg';
import surgePricingAct from '../../assets/icons/surgePricingAct.svg';
import customerDriver from '../../assets/icons/customerDriver.svg';
import customerDriverAct from '../../assets/icons/customerDriverAct.svg';
import driverDocs from '../../assets/icons/driverDocs.svg';
import driverDocsAct from '../../assets/icons/driverDocsAct.svg';
import mapView from '../../assets/icons/mapView.svg';
import mapViewAct from '../../assets/icons/mapViewAct.svg';
import promotions from '../../assets/icons/promotions.svg';
import promotionsAct from '../../assets/icons/promotionsAct.svg';
import pushes from '../../assets/icons/pushes.svg';
import pushesInact from '../../assets/icons/pushesInact.svg';
import tmsLocation from '../../assets/icons/tmsLocation.svg';
import tmsLocationInact from '../../assets/icons/tmsLocationInact.svg';
import tmsBookingInact from '../../assets/icons/tmsbookingInAct.svg';
import tmsBookingAct from '../../assets/icons/tmsBookingAct.svg';
import tmsDispatchInact from '../../assets/icons/tmsDispatchInact.svg';
import tmsDispatchAct from '../../assets/icons/tmsDispatchAct.svg';
import tmsInspectionInact from '../../assets/icons/inspectionInact.svg';
import tmsInspectionAct from '../../assets/icons/tmsInspectionAct.svg';
import tmsVehicleAct from '../../assets/icons/tmsVehicleAct.svg';
import tmsVehicleInact from '../../assets/icons/tmsVehicleInact.svg';
import tmsClockTowerAct from '../../assets/icons/tmsClockToweAct.svg';
import tmsClockTowerInact from '../../assets/icons/tmsClockTowerInact.svg';
import fuelConsumption from '../../assets/icons/fuelConsumption.svg';
import fuelConsumptionInact from '../../assets/icons/fuelConsumptionInact.svg';
import driverSubsAct from '../../assets/icons/driverSubsAct.svg';
import driverSubsInact from '../../assets/icons/driverSubsInact.svg';
import chatAct from '../../assets/icons/chatAct.svg';
import chatInact from '../../assets/icons/chatInact.svg';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import ShiftTimingAct from '../../assets/icons/shiftTimingAct.svg';
import ShiftTimingInact from '../../assets/icons/shiftTimingInact.svg';



const Sidemenu = () => {
    // const [isOpen, setIsOpen] = useState(true);

    // const handleToggle = () => {
    //     setIsOpen(!isOpen);
    // };
    const [isOpen, setIsOpen] = useState(() => {
        // Retrieve isOpen from local storage or default to true
        return JSON.parse(localStorage.getItem('sidebarIsOpen')) ?? true;
    });

    const handleToggle = () => {
        setIsOpen((prevState) => {
            const newState = !prevState;
            localStorage.setItem('sidebarIsOpen', JSON.stringify(newState));
            return newState;
        });
    };
    
    const location = useLocation();
    const sidebarRef = useRef(null);
    useEffect(() => {
        const savedScrollPosition = sessionStorage.getItem('sidebarScrollPosition');
        if (sidebarRef.current && savedScrollPosition) {
            sidebarRef.current.scrollTop = parseInt(savedScrollPosition, 10);
        }
    }, []);

    // Save scroll position whenever it changes
    const handleScroll = () => {
        if (sidebarRef.current) {
            sessionStorage.setItem('sidebarScrollPosition', sidebarRef.current.scrollTop);
        }
    };

    const isActive = (path) => location.pathname === path;

    // Retrieve allowed tabs from local storage
    const allowedTabsStr = JSON.parse(localStorage.getItem('clientRoleTabs')) || " ";

    const allowedTabs = allowedTabsStr?.split(',').map(Number);

    const SidebarTabs = constants.SidebarTabs;

    const corporateId = localStorage.getItem('corporateId');
    const isCorporatePanel = Boolean(corporateId && corporateId !== '0' && corporateId !== 'undefined' && corporateId !== 'null');

    // Helper function to check if a tab should be displayed
    const hasPermission = (tabId) => allowedTabs.includes(tabId);

    const rideTypes = [
        { label: 'Ongoing Rides', path: '/rides/ongoing' },
        { label: 'Completed Rides', path: '/rides/completed' },
        { label: 'Cancelled Rides', path: '/rides/cancelled' },
        { label: 'Missed Rides', path: '/rides/timeout' },
        // { label: 'Disputed Rides', path: '/rides/dispute' }
    ];
    //testing
      
    return (
        <Sidebar onScroll={handleScroll} ref={sidebarRef} collapsed={!isOpen} className="custom-sidebar">
            <div
                onClick={handleToggle}
                style={{ cursor: 'pointer', padding: '10px', textAlign: 'right',position: 'sticky',top: 0,backgroundColor: '#fff',zIndex: 10 }}
            >
                {!isOpen && (
                    <img src={toOpen} alt="menu icon" width="38px" height="38px" style={{marginRight:'12px'}} />
                )}
                
                {isOpen && (
                    <img src={menuButton} alt="menu icon" width="36px" height="36px" />
                )}
            </div>

            <Typography sx={{marginLeft: isOpen ? '6%' : '24%', color: isCorporatePanel ? '#D1D5DB' : '#D1D5DB', backgroundColor:'#fff', fontSize: isCorporatePanel?'20px':'12px', fontWeight: isCorporatePanel ? 600 : 400}}>
                {isCorporatePanel && isOpen ? 'Corporate Menu' : 'Menu'}
            </Typography>
            <Menu>
                {hasPermission(SidebarTabs.DASHBOARD) && (
                    <Grid2 sx={{backgroundColor: isActive('/mainDashboard') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Dashboard"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/mainDashboard'))
                                    ? <img src={dashboardActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={dashboardIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/mainDashboard" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/mainDashboard') ? '#F3F8FF' : '#fff',
                                color: isActive('/mainDashboard') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}
                
                {hasPermission(SidebarTabs.FLEET_DASHBOARD) && (
                    <Grid2 sx={{backgroundColor: isActive('/fleet-dashboard') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Dashboard"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/fleet-dashboard'))
                                    ? <img src={dashboardActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={dashboardIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/fleet-dashboard" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/fleet-dashboard') ? '#F3F8FF' : '#fff',
                                color: isActive('/fleet-dashboard') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.CORPORATE_DASHBOARD) && (
                    <Grid2 sx={{backgroundColor: isActive('/corporate_dashboard') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Corporate Dashboard"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/corporate_dashboard'))
                                    ? <img src={dashboardActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={dashboardIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/corporate_dashboard" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/corporate_dashboard') ? '#F3F8FF' : '#fff',
                                color: isActive('/corporate_dashboard') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.MERCHANT_DASHBOARD) && (
                    <Grid2 sx={{backgroundColor: isActive('/merchant_dashboard') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Merchant Dashboard"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/merchant_dashboard'))
                                    ? <img src={dashboardActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={dashboardIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/merchant_dashboard" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/merchant_dashboard') ? '#F3F8FF' : '#fff',
                                color: isActive('/merchant_dashboard') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.TMS_DASHBOARD) && (
                    <Grid2 sx={{backgroundColor: isActive('/tms-dashboard') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Dashboard"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/tms-dashboard'))
                                    ? <img src={dashboardActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={dashboardIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/tms-dashboard" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/tms-dashboard') ? '#F3F8FF' : '#fff',
                                color: isActive('/tms-dashboard') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.AT_DASHBOARD) && (
                    <Grid2 sx={{backgroundColor: isActive('/at-dashboard') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Dashboard"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/at-dashboard'))
                                    ? <img src={dashboardActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={dashboardIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/at-dashboard" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/at-dashboard') ? '#F3F8FF' : '#fff',
                                color: isActive('/at-dashboard') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.TMS_CLOCK_TOWER) && (
                    <Grid2 sx={{backgroundColor: isActive('/tms-clock-tower') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Control Tower"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/tms-clock-tower'))
                                    ? <img src={tmsClockTowerAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={tmsClockTowerInact} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/tms-clock-tower" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/tms-clock-tower') ? '#F3F8FF' : '#fff',
                                color: isActive('/tms-clock-tower') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {(hasPermission(SidebarTabs.SHUTTLESTOPS) || hasPermission(SidebarTabs.SHUTTLEROUTES) || hasPermission(SidebarTabs.SHUTTLEVEHICLE) || hasPermission(SidebarTabs.SHUTTLEFARE) || hasPermission(SidebarTabs.SHUTTLETRIP) || hasPermission(SidebarTabs.SHUTTLEBOOKING) || hasPermission(SidebarTabs.SHUTTLECNCELLATION) || hasPermission(SidebarTabs.SHUTTLESUBSCRIPTION) || hasPermission(SidebarTabs.SHUTTLESUBSCRIPTION) || hasPermission(SidebarTabs.SUGGESTED_ROUTES) || hasPermission(SidebarTabs.SHUTTLE_PROMOTIONS) || hasPermission(SidebarTabs.SHUTTLE_HOLIDAY) || hasPermission(SidebarTabs.SHUTTLE_PASS)) && (
                    <Grid2 sx={{backgroundColor: (isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation')|| isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/shuttle-booking') || isActive('/shuttle-subscription') || isActive('/cancellation-reasons') || isActive('/suggested-routes') || isActive('/shuttle-promotions') || isActive('/shuttle-holiday') || isActive('/shuttle-pass')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                        <SubMenu
                            label="Shuttle"
                            defaultOpen="true"
                            icon = {
                                (isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation')|| isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/shuttle-booking') || isActive('/shuttle-subscription') || isActive('/cancellation-reasons') || isActive('/suggested-routes') || isActive('/shuttle-promotions') || isActive('/shuttle-holiday') || isActive('/shuttle-pass'))
                                    ? <img src={customerDriverAct} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={customerDriver} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/shuttle-booking') || isActive('/shuttle-subscription') || isActive('/cancellation-reasons') || isActive('/suggested-routes') || isActive('/shuttle-promotions') || isActive('/shuttle-holiday') || isActive('/shuttle-pass') ? '#F3F8FF' : '#fff',
                                color: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/shuttle-booking') || isActive('/shuttle-subscription') || isActive('/cancellation-reasons') || isActive('/suggested-routes') || isActive('/shuttle-promotions') || isActive('/shuttle-holiday') || isActive('/shuttle-pass') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: '1px solid #E6F0FF'
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                                {hasPermission(SidebarTabs.SHUTTLESTOPS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/shuttle-stops') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/shuttle-stops" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-stops') ? '#F3F8FF' : '#fff',
                                                color: isActive('/shuttle-stops') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-stops') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Stops
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLEROUTES) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-routes') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-routes" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-routes') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-routes') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-routes') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Routes
                                        </MenuItem>
                                    </Grid2> 
                                )}

                                {hasPermission(SidebarTabs.SHUTTLEVEHICLE) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-vehicle') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-vehicle" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-vehicle') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-vehicle') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-vehicle') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Vehicles
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLEFARE) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-fare') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-fare" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-fare') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-fare') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-fare') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Fare
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLETRIP) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-journey') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-journey" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-journey') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-journey') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-journey') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Trips
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLEBOOKING) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/shuttle-booking') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-booking') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-booking" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-booking') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-booking') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-booking') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Analytics
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLECNCELLATION) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-cancellation') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-cancellation" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-cancellation') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-cancellation') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-cancellation') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Cancellation
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLE_CANCELLATION_REASONS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/cancellation-reasons') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/cancellation-reasons') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/cancellation-reasons" />}
                                            style={{
                                                backgroundColor: isActive('/cancellation-reasons') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/cancellation-reasons') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/cancellation-reasons') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Cancellation Reasons
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLESUBSCRIPTION) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-subscription') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-subscription" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-subscription') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-subscription') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-subscription') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Subscription
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLE_PROMOTIONS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/shuttle-promotions') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-promotions') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-promotions" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-promotions') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-promotions') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-promotions') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Promotions
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SUGGESTED_ROUTES) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/cancellation-reasons' || isActive('/suggested-routes')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/suggested-routes') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/suggested-routes" />}
                                            style={{
                                                backgroundColor: isActive('/suggested-routes') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/suggested-routes') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/suggested-routes') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Suggested Routes
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLE_HOLIDAY) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-holiday') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/shuttle-holiday') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-holiday') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-holiday" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-holiday') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-holiday') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-cancellation') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Holiday
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SHUTTLE_PASS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/shuttle-stops') || isActive('/shuttle-routes') || isActive('/shuttle-fare') || isActive('/shuttle-cancellation') || isActive('/shuttle-subscription') || isActive('/shuttle-vehicle') || isActive('/shuttle-journey') || isActive('/cancellation-reasons' || isActive('/suggested-routes') || isActive('/shuttle-pass')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/shuttle-pass') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/shuttle-pass" />}
                                            style={{
                                                backgroundColor: isActive('/shuttle-pass') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/shuttle-pass') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/shuttle-pass') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Shuttle Pass
                                        </MenuItem>
                                    </Grid2>
                                )}
                            </Grid2>
                            
                        </SubMenu>
                    </Grid2>
                )}
                
                {/* Rides SubMenu */}
                {hasPermission(SidebarTabs.RIDES) && (
                    <Grid2
                        sx={{
                            backgroundColor: (rideTypes.some((ride) => isActive(ride.path) || isActive('/rides/dispute') || isActive('/scheduled-bookings') || isActive('/requested-rides')) && isOpen) ? '#F3F8FF' : '#fff',
                            padding: '8px',
                            borderRadius: '8px',
                            margin: '4px',
                        }}
                    >
                        <SubMenu
                            label="Rides"
                            defaultOpen="true"
                            icon={
                                rideTypes.some((ride) => isActive(ride.path) || isActive('/rides/dispute')|| isActive('/scheduled-bookings') || isActive('/requested-rides')) ? (
                                    <img
                                        src={vehicleIcon}
                                        width="36px"
                                        height="36px"
                                        style={{ paddingLeft: !isOpen ? '4px' : '0px' }}
                                    />
                                ) : (
                                    <img
                                        src={vehicleInactive}
                                        width="36px"
                                        height="36px"
                                        style={{ paddingLeft: !isOpen ? '4px' : '0px' }}
                                    />
                                )
                            }
                            style={{
                                paddingLeft: '8px',
                                borderRadius: '8px',
                                backgroundColor: rideTypes.some((ride) => isActive(ride.path) || isActive('/rides/dispute') || isActive('/scheduled-bookings') || isActive('/requested-rides')) ? '#F3F8FF' : '#fff',
                                color: rideTypes.some((ride) => isActive(ride.path) ||isActive('/rides/dispute') || isActive('/scheduled-bookings') || isActive('/requested-rides')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            {hasPermission(SidebarTabs.SCHEDULED_BOOKINGS) && (
                                <Grid2 sx={{
                                    display: 'flex', alignItems:'center',
                                    backgroundColor: (isActive('/scheduled-bookings')) && isOpen ? '#fff' : '#fff',
                                    padding: '4px',borderRadius: '8px', paddingLeft:'6%'
                                }}>
                                    <FiberManualRecordIcon 
                                        sx={{ color: (isActive('/scheduled-bookings')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                    <MenuItem className='subItems' component={<Link to="/scheduled-bookings" />}
                                        style={{
                                            backgroundColor: (isActive('/scheduled-bookings')) ? '#F3F8FF' : '#fff', 
                                            color: (isActive('/scheduled-bookings')) ? '#0065FF' : '#83888E',
                                            borderRadius: (isActive('/scheduled-bookings')) ? '8px':'0', paddingLeft:'20px',
                                            // marginRight:'10px'
                                        }}>
                                        
                                        Scheduled Bookings
                                    </MenuItem>
                                </Grid2>
                            )}

                            {hasPermission(SidebarTabs.REQUESTED_RIDES) && (
                                <Grid2 sx={{
                                    display: 'flex', alignItems:'center',
                                    backgroundColor: (isActive('/requested-rides')) && isOpen ? '#fff' : '#fff',
                                    padding: '4px',borderRadius: '8px', paddingLeft:'6%'
                                }}>
                                    <FiberManualRecordIcon 
                                        sx={{ color: (isActive('/requested-rides')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                    <MenuItem className='subItems' component={<Link to="/requested-rides" />}
                                        style={{
                                            backgroundColor: (isActive('/requested-rides')) ? '#F3F8FF' : '#fff', 
                                            color: (isActive('/requested-rides')) ? '#0065FF' : '#83888E',
                                            borderRadius: (isActive('/requested-rides')) ? '8px':'0', paddingLeft:'20px',
                                            // marginRight:'10px'
                                        }}>
                                        
                                        Requested Rides
                                    </MenuItem>
                                </Grid2>
                            )}

                            {hasPermission(SidebarTabs.RIDES) && (
                                <Grid2 item sx={{backgroundColor:'#fff', padding:'0% 4%'}}>
                                    {rideTypes.map((ride, index) => (
                                        <Grid2
                                            key={index}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '4px',
                                                backgroundColor: isActive(ride.path) ? '#fff' : '#fff',
                                                color: isActive(ride.path) ? '#0065FF' : '#83888E',
                                                borderRadius: '8px',
                                            }}
                                        >
                                            <FiberManualRecordIcon
                                                sx={{
                                                    color: isActive(ride.path) ? '#0065FF' : '#83888E',
                                                    marginRight: '8px',
                                                    width: '16px',
                                                }}
                                            />
                                            <MenuItem
                                                className="subItems"
                                                component={<Link to={ride.path} />}
                                                style={{
                                                    paddingLeft: '20px',
                                                    backgroundColor: isActive(ride.path) ? '#F3F8FF' : '#fff',
                                                    color: isActive(ride.path) ? '#0065FF' : '#83888E',
                                                    borderRadius: isActive(ride.path) ? '8px' : '0',
                                                }}
                                            >
                                                {ride.label}
                                            </MenuItem>
                                        </Grid2>
                                    ))}
                                </Grid2>
                            )}

                            {hasPermission(SidebarTabs.DRIVER_MISSED_RIDES) && (
                                <Grid2 sx={{
                                    display: 'flex', alignItems:'center',
                                    backgroundColor: (isActive('/missed-rides')) && isOpen ? '#fff' : '#fff',
                                    padding: '4px',borderRadius: '8px', paddingLeft:'6%'
                                }}>
                                    <FiberManualRecordIcon 
                                        sx={{ color: (isActive('/missed-rides')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                    <MenuItem className='subItems' component={<Link to="/missed-rides" />}
                                        style={{
                                            backgroundColor: (isActive('/missed-rides')) ? '#F3F8FF' : '#fff', 
                                            color: (isActive('/missed-rides')) ? '#0065FF' : '#83888E',
                                            borderRadius: (isActive('/missed-rides')) ? '8px':'0', paddingLeft:'20px',
                                            // marginRight:'10px'
                                        }}>
                                        
                                        Driver Missed Requests
                                    </MenuItem>
                                </Grid2>
                            )}

                            {hasPermission(SidebarTabs.DISPUTERIDES) &&
                                <Grid2 sx={{
                                    display: 'flex', alignItems:'center',
                                    backgroundColor: (isActive('/rides/dispute')) && isOpen ? '#fff' : '#fff',
                                    padding: '4px',borderRadius: '8px', paddingLeft:'6%'
                                }}>
                                    <FiberManualRecordIcon 
                                        sx={{ color: (isActive('/rides/dispute')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                    <MenuItem className='subItems' component={<Link to="/rides/dispute" />}
                                        style={{
                                            backgroundColor: (isActive('/rides/dispute')) ? '#F3F8FF' : '#fff', 
                                            color: (isActive('/rides/dispute')) ? '#0065FF' : '#83888E',
                                            borderRadius: (isActive('/rides/dispute')) ? '8px':'0', paddingLeft:'20px',
                                            // marginRight:'10px'
                                        }}>
                                        
                                        Dispute Rides
                                    </MenuItem>
                                </Grid2>
                            }
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.MAPVIEW) && (
                    <Grid2 sx={{backgroundColor: isActive('/mapView') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        {/* {hasPermission(SidebarTabs.GEOFENCE) && ( */}
                            <SubMenu
                                label="Map View"
                                defaultOpen="true"
                                className="submenu-no-arrow"
                                icon = {
                                    (isActive('/mapView'))
                                        ? <img src={mapViewAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                        : <img src={mapView} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                }
                                component={<Link to="/mapView" />}
                                style={{
                                    paddingLeft:'8px',
                                    borderRadius: '8px',
                                    backgroundColor: isActive('/mapView') ? '#F3F8FF' : '#fff',
                                    color: isActive('/mapView') ? '#1A1E25' : '#83888E',
                                    transition: 'all 0.3s ease',
                                }}
                                >
                            </SubMenu>
                        {/* )} */}
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.SHIFT_TIMING) && (
                    <Grid2 sx={{backgroundColor: isActive('/shift-timing') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        {/* {hasPermission(SidebarTabs.GEOFENCE) && ( */}
                            <SubMenu
                                label="Shift Timing"
                                defaultOpen="true"
                                className="submenu-no-arrow"
                                icon = {
                                    (isActive('/shift-timing'))
                                        ? <img src={ShiftTimingAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                        : <img src={ShiftTimingInact} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                }
                                component={<Link to="/shift-timing" />}
                                style={{
                                    paddingLeft:'8px',
                                    borderRadius: '8px',
                                    backgroundColor: isActive('/shift-timing') ? '#F3F8FF' : '#fff',
                                    color: isActive('/shift-timing') ? '#1A1E25' : '#83888E',
                                    transition: 'all 0.3s ease',
                                }}
                                >
                            </SubMenu>
                        {/* )} */}
                    </Grid2>
                )}


                {(hasPermission(SidebarTabs.CHAT) || hasPermission(SidebarTabs.CHAT_LOGS)) && (
                    <Grid2 sx={{backgroundColor: (isActive('/user-logs') || isActive('/support-chat')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                        <SubMenu
                            label="Chat Logs"
                            defaultOpen="true"
                            icon = {
                                (isActive('/user-logs') || (isActive('/support-chat')))
                                    ? <img src={chatAct} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={chatInact} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: (isActive('/user-logs') || isActive('/support-chat')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/user-logs') || isActive('/support-chat')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                                {hasPermission(SidebarTabs.CHAT_LOGS) &&
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/user-logs')) && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/user-logs' ) ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/user-logs" />}
                                            style={{
                                                backgroundColor: isActive('/user-logs') ? '#F3F8FF' : '#fff',
                                                color: isActive('/user-logs') ? '#0065FF' : '#83888E',
                                                // border: isActive('/rider-details') ? '1px solid #96C0FF':'none',
                                                borderRadius: isActive('/user-logs') ? '8px':'0',
                                                // marginLeft: isActive('/rider-details') ? '0' : '4%',
                                                paddingLeft: '20px',
                                                // marginLeft: isOpen ? '16px' : '0px'
                                            }}
                                        >
                                            User Logs
                                        </MenuItem>
                                    </Grid2>
                                } 
                                {hasPermission(SidebarTabs.CHAT) && 
                                   <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/support-chat')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: (isActive('/support-chat')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/support-chat" />}
                                            style={{
                                                backgroundColor: (isActive('/support-chat')) ? '#F3F8FF' : '#fff', 
                                                color: (isActive('/support-chat')) ? '#0065FF' : '#83888E',
                                                // border: isActive('/') ? '1px solid #96C0FF':'none',
                                                borderRadius: (isActive('/support-chat')) ? '8px':'0', paddingLeft:'20px',
                                                // marginLeft: isOpen ? '16px' : '0px', margin:'8px 0px 8px 40px'
                                            }}>
                                            
                                            Support Chat
                                        </MenuItem>
                                    </Grid2>
                                }

                            </Grid2>
                            
                        </SubMenu>
                    </Grid2>
                )}
                

                {/* {hasPermission(SidebarTabs.AIRPORT_TRANSFER_REQUESTED_BOOKING) && (
                    <Grid2 sx={{backgroundColor: isActive('/airport-transfer-booking') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Booking"
                            defaultOpen="true"
                            icon = {
                                (isActive('/airport-transfer-booking'))
                                    ? <img src={userIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={userInactive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/airport-transfer-booking" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/airport-transfer-booking') ? '#F3F8FF' : '#fff',
                                color: isActive('/airport-transfer-booking') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )} */}

                {(hasPermission(SidebarTabs.AIRPORT_TRANSFER_REQUESTED_BOOKING) || hasPermission(SidebarTabs.AIRPORT_TRANSFER_REQUESTED_BOOKING)) && (
                    <Grid2 sx={{backgroundColor: (isActive('/airport-transfer-booking') || isActive('/at-assigned-trips') || isActive('/at-cancelled-trips') || isActive('/at-completed-trips') || isActive('/at-no-show-trips') || isActive('/at-ongoing-trips') || isActive('/all-bookings')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                        <SubMenu
                            label="Booking"
                            defaultOpen="true"
                            icon = {
                                (isActive('/airport-transfer-booking') || isActive('/at-assigned-trips') || isActive('/at-cancelled-trips') || isActive('/at-completed-trips') || isActive('/at-no-show-trips') || isActive('/at-ongoing-trips') || isActive('/all-bookings'))
                                    ? <img src={customerDriverAct} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={customerDriver} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/airport-transfer-booking') || isActive('/at-assigned-trips') || isActive('/at-cancelled-trips') || isActive('/at-completed-trips') || isActive('/at-no-show-trips') || isActive('/at-ongoing-trips') || isActive('/all-bookings') ? '#F3F8FF' : '#fff',
                                color: isActive('/airport-transfer-booking') || isActive('/at-assigned-trips') || isActive('/at-cancelled-trips') || isActive('/at-completed-trips') || isActive('/at-no-show-trips') || isActive('/at-ongoing-trips') || isActive('/all-bookings') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: '1px solid #E6F0FF'
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                                {hasPermission(SidebarTabs.AT_ALL_BOOKINGS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/at-assigned-trips') || isActive('/at-assigned-trips') || isActive('/at-cancelled-trips') || isActive('/at-completed-trips') || isActive('/at-no-show-trips') || isActive('/at-ongoing-trips') || isActive('/all-bookings') && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/all-bookings') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' 
                                        component={<Link to="/all-bookings" />}
                                            style={{
                                                backgroundColor: isActive('/all-bookings') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/all-bookings') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/all-bookings') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            All Bookings
                                        </MenuItem>
                                    </Grid2> 
                                )}
                                {hasPermission(SidebarTabs.AIRPORT_TRANSFER_REQUESTED_BOOKING) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/airport-transfer-booking') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/airport-transfer-booking') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/airport-transfer-booking" />}
                                            style={{
                                                backgroundColor: isActive('/airport-transfer-booking') ? '#F3F8FF' : '#fff',
                                                color: isActive('/airport-transfer-booking') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/airport-transfer-booking') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Requested Bookings
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.AT_ASSIGNED_TRIPS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/at-assigned-trips') || isActive('/at-assigned-trips') || isActive('/at-cancelled-trips') || isActive('/at-completed-trips') || isActive('/at-no-show-trips') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/at-assigned-trips') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' 
                                        component={<Link to="/at-assigned-trips" />}
                                            style={{
                                                backgroundColor: isActive('/at-assigned-trips') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/at-assigned-trips') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/at-assigned-trips') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            Assigned Trip
                                        </MenuItem>
                                    </Grid2> 
                                )}

                                {hasPermission(SidebarTabs.AT_CANCELLED_TRIPS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/airport-transfer-booking') || isActive('/at-cancelled-trips') || isActive('/at-assigned-trips') || isActive('/at-completed-trips')|| isActive('/at-no-show-trips') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/at-cancelled-trips') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' 
                                        component={<Link to="/at-cancelled-trips" />}
                                            style={{
                                                backgroundColor: isActive('/at-cancelled-trips') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/at-cancelled-trips') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/at-cancelled-trips') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            Cancelled Trip
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.AT_ONGOING_TRIPS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/airport-transfer-booking') || isActive('/at-assigned-trips') || isActive('/at-cancelled-trips') || isActive('/at-completed-trips')|| isActive('/at-no-show-trips') || isActive('/at-no-show-trips') || isActive('/at-ongoing-trips') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/at-ongoing-trips') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' 
                                        component={<Link to="/at-ongoing-trips" />}
                                            style={{
                                                backgroundColor: isActive('/at-ongoing-trips') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/at-ongoing-trips') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/at-ongoing-trips') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            Ongoing Trips
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.AT_COMPLETED_TRIPS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/airport-transfer-booking') || isActive('/at-assigned-trips') || isActive('/at-cancelled-trips') || isActive('/at-completed-trips')|| isActive('/at-no-show-trips') || isActive('/at-completed-trips') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/at-completed-trips') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' 
                                        component={<Link to="/at-completed-trips" />}
                                            style={{
                                                backgroundColor: isActive('/at-completed-trips') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/at-completed-trips') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/at-completed-trips') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            Completed Trip
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.AT_NO_SHOW_TRIP) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/airport-transfer-booking') || isActive('/at-assigned-trips') || isActive('/at-cancelled-trips') || isActive('/at-completed-trips')|| isActive('/at-no-show-trips') || isActive('/at-no-show-trips') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/at-no-show-trips') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' 
                                        component={<Link to="/at-no-show-trips" />}
                                            style={{
                                                backgroundColor: isActive('/at-no-show-trips') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/at-no-show-trips') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/at-no-show-trips') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            No Show Trip
                                        </MenuItem>
                                    </Grid2>
                                )}
                            </Grid2>
                            
                        </SubMenu>
                    </Grid2>
                )}
                
                {hasPermission(SidebarTabs.TMS_BOOKING) && (
                    <Grid2 sx={{backgroundColor: isActive('/tms-booking') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Booking"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/tms-booking'))
                                    ? <img src={tmsBookingAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={tmsBookingInact} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/tms-booking" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/tms-booking') ? '#F3F8FF' : '#fff',
                                color: isActive('/tms-booking') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {(hasPermission(SidebarTabs.TMS_ASSIGNED_DISPATCH) || hasPermission(SidebarTabs.TMS_UNASSIGNED_DISPATCH) || hasPermission(SidebarTabs.TMS_CANCELLED_DISPATCH) || hasPermission(SidebarTabs.TMS_ONGOING_DISPATCH) || hasPermission(SidebarTabs.TMS_DELIVERED_DISPATCH) || hasPermission(SidebarTabs.TMS_FOUL_DISPATCH)) && (
                    <Grid2 sx={{backgroundColor: (isActive('/tms-assigned-dispatch') || isActive('/tms-unassigned-dispatch') || isActive('/tms-cancelled-dispatch') || isActive('/tms-ongoing-dispatch')|| isActive('/tms-foul-dispatch') || isActive('/tms-delivered-dispatch')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                        <SubMenu
                            label="Dispatch"
                            defaultOpen="true"
                            icon = {
                                (isActive('/tms-assigned-dispatch') || isActive('/tms-unassigned-dispatch') || isActive('/tms-cancelled-dispatch') || isActive('/tms-ongoing-dispatch')|| isActive('/tms-foul-dispatch') || isActive('/tms-delivered-dispatch'))
                                    ? <img src={tmsDispatchAct} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={tmsDispatchInact} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/tms-assigned-dispatch') || isActive('/tms-unassigned-dispatch') || isActive('/tms-cancelled-dispatch') || isActive('/tms-ongoing-dispatch')|| isActive('/tms-foul-dispatch') || isActive('/tms-delivered-dispatch') ? '#F3F8FF' : '#fff',
                                color: isActive('/tms-assigned-dispatch') || isActive('/tms-unassigned-dispatch') || isActive('/tms-cancelled-dispatch') || isActive('/tms-ongoing-dispatch')|| isActive('/tms-foul-dispatch') || isActive('/tms-delivered-dispatch') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: '1px solid #E6F0FF'
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                                {hasPermission(SidebarTabs.TMS_ASSIGNED_DISPATCH) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/tms-assigned-dispatch') && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/tms-assigned-dispatch') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/tms-assigned-dispatch" />}
                                            style={{
                                                backgroundColor: isActive('/tms-assigned-dispatch') ? '#F3F8FF' : '#fff',
                                                color: isActive('/tms-assigned-dispatch') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-assigned-dispatch') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Assigned
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TMS_UNASSIGNED_DISPATCH) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/tms-assigned-dispatch') || isActive('/tms-unassigned-dispatch') || isActive('/tms-cancelled-dispatch') || isActive('/tms-ongoing-dispatch')|| isActive('/tms-foul-dispatch') || isActive('/tms-delivered-dispatch') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/tms-unassigned-dispatch') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/tms-unassigned-dispatch" />}
                                            style={{
                                                backgroundColor: isActive('/tms-unassigned-dispatch') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/tms-unassigned-dispatch') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-unassigned-dispatch') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Unassigned
                                        </MenuItem>
                                    </Grid2> 
                                )}

                                {hasPermission(SidebarTabs.TMS_CANCELLED_DISPATCH) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/tms-assigned-dispatch') || isActive('/tms-unassigned-dispatch') || isActive('/tms-cancelled-dispatch') || isActive('/tms-ongoing-dispatch')|| isActive('/tms-foul-dispatch') || isActive('/tms-delivered-dispatch') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/tms-cancelled-dispatch') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/tms-cancelled-dispatch" />}
                                            style={{
                                                backgroundColor: isActive('/tms-cancelled-dispatch') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/tms-cancelled-dispatch') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-cancelled-dispatch') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            Cancelled
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TMS_ONGOING_DISPATCH) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/tms-assigned-dispatch') || isActive('/tms-unassigned-dispatch') || isActive('/tms-cancelled-dispatch') || isActive('/tms-ongoing-dispatch')|| isActive('/tms-foul-dispatch') || isActive('/tms-delivered-dispatch') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/tms-ongoing-dispatch') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/tms-ongoing-dispatch" />}
                                            style={{
                                                backgroundColor: isActive('/tms-ongoing-dispatch') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/tms-ongoing-dispatch') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-ongoing-dispatch') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            Ongoing
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TMS_DELIVERED_DISPATCH) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/tms-assigned-dispatch') || isActive('/tms-unassigned-dispatch') || isActive('/tms-cancelled-dispatch') || isActive('/tms-ongoing-dispatch')|| isActive('/tms-foul-dispatch') || isActive('/tms-delivered-dispatch') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/tms-delivered-dispatch') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/tms-delivered-dispatch" />}
                                            style={{
                                                backgroundColor: isActive('/tms-delivered-dispatch') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/tms-delivered-dispatch') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-delivered-dispatch') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            Delivered
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TMS_FOUL_DISPATCH) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: isActive('/tms-assigned-dispatch') || isActive('/tms-unassigned-dispatch') || isActive('/tms-cancelled-dispatch') || isActive('/tms-ongoing-dispatch')|| isActive('/tms-foul-dispatch') || isActive('/tms-delivered-dispatch') && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: isActive('/tms-foul-dispatch') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/tms-foul-dispatch" />}
                                            style={{
                                                backgroundColor: isActive('/tms-foul-dispatch') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/tms-foul-dispatch') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-foul-dispatch') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            Foul Trips
                                        </MenuItem>
                                    </Grid2>
                                )}
                            </Grid2>
                            
                        </SubMenu>
                    </Grid2>
                )}

                {/* Manual dispatch will come here */}
                {hasPermission(SidebarTabs.DISPATCHER) && (
                    <Grid2 sx={{backgroundColor: isActive('/dispatcher') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Manual Dispatcher"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/dispatcher'))
                                    ? <img src={userIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={userInactive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/dispatcher" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/dispatcher') ? '#F3F8FF' : '#fff',
                                color: isActive('/dispatcher') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.MANUAL_REQUESTED_TRIPS) && (
                    <Grid2 sx={{backgroundColor: isActive('/manual-trips') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Manual Trips"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/manual-trips'))
                                    ? <img src={userIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={userInactive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/manual-trips" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/manual-trips') ? '#F3F8FF' : '#fff',
                                color: isActive('/manual-trips') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.TMS_INSPECTION) && (
                    <Grid2 sx={{backgroundColor: isActive('/inspection') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Inspection"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/inspection'))
                                    ? <img src={tmsInspectionAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={tmsInspectionInact} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/inspection" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/inspection') ? '#F3F8FF' : '#fff',
                                color: isActive('/inspection') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {(hasPermission(SidebarTabs.CUSTOMER) || hasPermission(SidebarTabs.DRIVER) || hasPermission(SidebarTabs.TMS_CLIENT) || hasPermission(SidebarTabs.TMS_HELPER) || hasPermission(SidebarTabs.TMS_TRUCK_VENDORS)) && (
                    <Grid2 sx={{backgroundColor: (isActive('/') || isActive('/rider-details') || isActive('/driver-details') || isActive('/tms-client') || isActive('/tms-helpers') || isActive('/tms-truck-vendors')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                        <SubMenu
                            label="Users"
                            defaultOpen="true"
                            icon = {
                                (isActive('/') || isActive('/rider-details') || isActive('/driver-details') || isActive('/tms-client') || isActive('/tms-helpers') || isActive('/tms-truck-vendors'))
                                    ? <img src={customerDriverAct} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={customerDriver} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: (isActive('/') || isActive('/rider-details') || isActive('/driver-details') || isActive('/tms-client') || isActive('/tms-helpers') || isActive('/tms-truck-vendors')) ? '#F3F8FF' : '#fff',
                                color: isActive('/') || isActive('/rider-details') || isActive('/driver-details') || isActive('/tms-client') || isActive('/tms-helpers') || isActive('/tms-truck-vendors') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: '1px solid #E6F0FF'
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>

                                {hasPermission(SidebarTabs.CUSTOMER) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/') || isActive('/rider-details')) && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/rider-details') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/rider-details" />}
                                            style={{
                                                backgroundColor: isActive('/rider-details') ? '#F3F8FF' : '#fff',
                                                color: isActive('/rider-details') ? '#0065FF' : '#83888E',
                                                // border: isActive('/rider-details') ? '1px solid #96C0FF':'none',
                                                borderRadius: isActive('/rider-details') ? '8px':'0',
                                                // marginLeft: isActive('/rider-details') ? '0' : '4%',
                                                paddingLeft: '20px',
                                                // marginLeft: isOpen ? '16px' : '0px'
                                            }}
                                        >
                                            Customer
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.DRIVER) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/') || isActive('/rider-details') || isActive('/driver-details')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: (isActive('/') || isActive('/driver-details')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/" />}
                                            style={{
                                                backgroundColor: (isActive('/') || isActive('/driver-details')) ? '#F3F8FF' : '#fff', 
                                                color: (isActive('/') || isActive('/driver-details')) ? '#0065FF' : '#83888E',
                                                // border: isActive('/') ? '1px solid #96C0FF':'none',
                                                borderRadius: (isActive('/') || isActive('/driver-details')) ? '8px':'0', paddingLeft:'20px',
                                                // marginLeft: isOpen ? '16px' : '0px', margin:'8px 0px 8px 40px'
                                            }}>
                                            
                                            Driver
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TMS_CLIENT) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/') || isActive('/rider-details') || isActive('/driver-details') || isActive('/tms-client')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                        sx={{ color: isActive('/tms-client') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/tms-client" />}
                                            style={{
                                                backgroundColor: isActive('/tms-client') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/tms-client') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-client') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Clients
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TMS_HELPER) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/') || isActive('/rider-details') || isActive('/driver-details') || isActive('/tms-client') || isActive('/tms-helpers')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                        sx={{ color: isActive('/tms-helpers') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/tms-helpers" />}
                                            style={{
                                                backgroundColor: isActive('/tms-helpers') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/tms-helpers') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-helpers') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Helpers
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TMS_TRUCK_VENDORS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/') || isActive('/rider-details') || isActive('/driver-details') || isActive('/tms-client') || isActive('/tms-truck-vendors')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                        sx={{ color: isActive('/tms-truck-vendors') ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/tms-truck-vendors" />}
                                            style={{
                                                backgroundColor: isActive('/tms-truck-vendors') ? '#F3F8FF' : '#fff', 
                                                color: isActive('/tms-truck-vendors') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-truck-vendors') ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Truck Vendors
                                        </MenuItem>
                                    </Grid2>
                                )}

                            </Grid2>
                            
                        </SubMenu>
                    </Grid2>
                )}
                {hasPermission(SidebarTabs.DELETE_ACCOUNT_REQUEST) && (
                    <Grid2 sx={{backgroundColor: isActive('/delete-account') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Delete Account Request"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/delete-account'))
                                    ? <img src={driverDocsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={driverDocs} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/delete-account" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/delete-account') ? '#F3F8FF' : '#fff',
                                color: isActive('/delete-account') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.DRIVER_PAYOUT) && (
                    <Grid2 sx={{backgroundColor: isActive('/driver-payouts') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Driver Payouts"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/driver-payouts'))
                                    ? <img src={driverDocsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={driverDocs} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/driver-payouts" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/driver-payouts') ? '#F3F8FF' : '#fff',
                                color: isActive('/driver-payouts') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.DRIVERDOCS) && (
                    <Grid2 sx={{backgroundColor: isActive('/driver-documents') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Driver Documents"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/driver-documents'))
                                    ? <img src={driverDocsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={driverDocs} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/driver-documents" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/driver-documents') ? '#F3F8FF' : '#fff',
                                color: isActive('/driver-documents') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.MERCHANT_REQUIRED_DOCUMENTS) && (
                    <Grid2 sx={{backgroundColor: isActive('/merchant-required_documents') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Merchant Documents"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/merchant-required_documents'))
                                    ? <img src={driverDocsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={driverDocs} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/merchant-required_documents" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/merchant-required_documents') ? '#F3F8FF' : '#fff',
                                color: isActive('/merchant-required_documents') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.CUSTOMERDOCS) && (
                    <Grid2 sx={{backgroundColor: isActive('/customer-documents') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Customer Documents"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/customer-documents'))
                                    ? <img src={driverDocsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={driverDocs} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/customer-documents" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/customer-documents') ? '#F3F8FF' : '#fff',
                                color: isActive('/drivcustomerer-documents') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {(hasPermission(SidebarTabs.TMS_TRUCKHEAD) || hasPermission(SidebarTabs.TMS_CHASSIS)) && (
                    <Grid2 sx={{backgroundColor: (isActive('/tms-truckhead') || isActive('/tms-chassis')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                        <SubMenu
                            label="Vehicle"
                            defaultOpen="true"
                            icon = {
                                (isActive('/tms-truckhead') || isActive('/tms-chassis'))
                                    ? <img src={tmsVehicleAct} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={tmsVehicleInact} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: (isActive('/tms-truckhead') || isActive('/tms-chassis')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/tms-truckhead') || isActive('/tms-chassis')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                                {hasPermission(SidebarTabs.TMS_TRUCKHEAD) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/tms-truckhead') || isActive('/tms-chassis')) && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/tms-truckhead') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/tms-truckhead" />}
                                            style={{
                                                backgroundColor: isActive('/tms-truckhead') ? '#F3F8FF' : '#fff',
                                                color: isActive('/tms-truckhead') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-truckhead') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Truck Head
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TMS_CHASSIS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/tms-chassis')) && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/tms-chassis') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/tms-chassis" />}
                                            style={{
                                                backgroundColor: isActive('/tms-chassis') ? '#F3F8FF' : '#fff',
                                                color: isActive('/tms-chassis') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-chassis') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Chassis
                                        </MenuItem>
                                    </Grid2>
                                )}
                            </Grid2>

                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.PROMOTIONS) && (
                    <Grid2 sx={{backgroundColor: (isActive('/promotions')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        {/* {hasPermission(SidebarTabs.ANALYTICS) && ( */}
                            <SubMenu
                                label="Promotions"
                                defaultOpen="true"
                            className="submenu-no-arrow"
                                icon = {
                                    (isActive('/promotions'))
                                        ? <img src={promotionsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                        : <img src={promotions} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                }
                                component={<Link to="/promotions" />}
                                style={{
                                    paddingLeft:'8px',
                                    // margin: '0 10px',
                                    borderRadius: '8px',
                                    // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                    backgroundColor: (isActive('/promotions')) ? '#F3F8FF' : '#fff',
                                    color: (isActive('/promotions')) ? '#1A1E25' : '#83888E',
                                    transition: 'all 0.3s ease',
                                    // border: isOpen ? '1px solid #E6F0FF' : 'none'
                                }}
                                >
                            </SubMenu>
                        {/* )} */}
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.PARTNERS) && (
                    <Grid2 sx={{backgroundColor: (isActive('/partners')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        {/* {hasPermission(SidebarTabs.ANALYTICS) && ( */}
                            <SubMenu
                                label="Partners"
                                defaultOpen="true"
                            className="submenu-no-arrow"
                                icon = {
                                    (isActive('/partners'))
                                        ? <img src={customerDriverAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                        : <img src={customerDriver} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                }
                                component={<Link to="/partners" />}
                                style={{
                                    paddingLeft:'8px',
                                    // margin: '0 10px',
                                    borderRadius: '8px',
                                    // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                    backgroundColor: (isActive('/partners')) ? '#F3F8FF' : '#fff',
                                    color: (isActive('/partners')) ? '#1A1E25' : '#83888E',
                                    transition: 'all 0.3s ease',
                                    // border: isOpen ? '1px solid #E6F0FF' : 'none'
                                }}
                                >
                            </SubMenu>
                        {/* )} */}
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.DRIVER_SUBSCRIPTION) && (
                    <Grid2 sx={{backgroundColor: (isActive('/driver-subscription') || isActive('/driver-analysis')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                        <SubMenu
                            label="Subscription Plan"
                            defaultOpen="true"
                            icon = {
                                (isActive('/driver-subscription') || (isActive('/driver-analysis')))
                                    ? <img src={driverSubsAct} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={driverSubsInact} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: (isActive('/driver-subscription') || isActive('/driver-analysis')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/driver-subscription') || isActive('/driver-analysis')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>

                                {hasPermission(SidebarTabs.DRIVER_SUBSCRIPTION) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/driver-subscription')) && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/driver-subscription' ) ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/driver-subscription" />}
                                            style={{
                                                backgroundColor: isActive('/driver-subscription') ? '#F3F8FF' : '#fff',
                                                color: isActive('/driver-subscription') ? '#0065FF' : '#83888E',
                                                // border: isActive('/rider-details') ? '1px solid #96C0FF':'none',
                                                borderRadius: isActive('/driver-subscription') ? '8px':'0',
                                                // marginLeft: isActive('/rider-details') ? '0' : '4%',
                                                paddingLeft: '20px',
                                                // marginLeft: isOpen ? '16px' : '0px'
                                            }}
                                        >
                                            Manage Plan
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.DRIVER_SUBSCRIPTION) && (
                                   <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/driver-analysis')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: (isActive('/driver-analysis')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/driver-analysis" />}
                                            style={{
                                                backgroundColor: (isActive('/driver-analysis')) ? '#F3F8FF' : '#fff', 
                                                color: (isActive('/driver-analysis')) ? '#0065FF' : '#83888E',
                                                // border: isActive('/') ? '1px solid #96C0FF':'none',
                                                borderRadius: (isActive('/driver-analysis')) ? '8px':'0', paddingLeft:'20px',
                                                // marginLeft: isOpen ? '16px' : '0px', margin:'8px 0px 8px 40px'
                                            }}>
                                            
                                            Report & Analysis
                                        </MenuItem>
                                    </Grid2> 
                                )}

                            </Grid2>
                            
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.VEHICLETYPE) && (
                    <Grid2 sx={{backgroundColor: isActive('/vehicles') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        
                            <SubMenu
                                label="Vehicle Type"
                                defaultOpen="true"
                            className="submenu-no-arrow"
                                icon = {
                                    (isActive('/vehicle'))
                                        ? <img src={vehicleIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                        : <img src={vehicleInactive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                }
                                component={<Link to="/vehicle" />}
                                style={{
                                    paddingLeft:'8px',
                                    // margin: '0 10px',
                                    borderRadius: '8px',
                                    // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                    backgroundColor: isActive('/vehicle') ? '#F3F8FF' : '#fff',
                                    color: isActive('/vehicle') ? '#1A1E25' : '#83888E',
                                    transition: 'all 0.3s ease',
                                    // border: isOpen ? '1px solid #E6F0FF' : 'none'
                                }}
                            >
                            </SubMenu>
                       
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.VEHICLEINFORMATION) && (
                    <Grid2 sx={{backgroundColor: isActive('/vehicle-information') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Vehicle Information "
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/vehicle-information'))
                                    ? <img src={vehicleIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={vehicleInactive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/vehicle-information" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/vehicle-information') ? '#F3F8FF' : '#fff',
                                color: isActive('/vehicle-information') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                        </SubMenu>
                 </Grid2>
                )}

                {hasPermission(SidebarTabs.FUEL_CONSUMPTION) && (
                    <Grid2 sx={{backgroundColor: isActive('/fuel-consumption') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Fuel Consumption"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/fuel-consumption'))
                                    ? <img src={fuelConsumption} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={fuelConsumptionInact} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/fuel-consumption" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/fuel-consumption') ? '#F3F8FF' : '#fff',
                                color: isActive('/fuel-consumption') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                        </SubMenu>
                 </Grid2>
                )}

                {hasPermission(SidebarTabs.SURGEPRICING) && (
                    <Grid2 sx={{backgroundColor: isActive('/surge-pricing') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        {/* {hasPermission(SidebarTabs.SURGEPRICING) && ( */}
                            <SubMenu
                                label="Surge Pricing"
                                defaultOpen="true"
                                className="submenu-no-arrow"
                                icon = {
                                    (isActive('/surge-pricing'))
                                        ? <img src={surgePricingAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                        : <img src={surgePricing} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                }
                                component={<Link to="/surge-pricing" />}
                                style={{
                                    paddingLeft:'8px',
                                    // margin: '0 10px',
                                    borderRadius: '8px',
                                    // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                    backgroundColor: isActive('/surge-pricing') ? '#F3F8FF' : '#fff',
                                    color: isActive('/surge-pricing') ? '#1A1E25' : '#83888E',
                                    transition: 'all 0.3s ease',
                                    // border: isOpen ? '1px solid #E6F0FF' : 'none'
                                }}
                            >
                            </SubMenu>
                        {/* )} */}
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.FLEETS) && (
                    <Grid2 sx={{backgroundColor: isActive('/fleets') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Fleets"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/fleets'))
                                    ? <img src={fleetActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={fleetInactive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/fleets" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/fleets') ? '#F3F8FF' : '#fff',
                                color: isActive('/fleets') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}
                {hasPermission(SidebarTabs.FLEET_DOCUMENTS) && (
                    <Grid2 sx={{backgroundColor: isActive('/fleet-documents') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Fleet Documents"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/fleet-documents'))
                                    ? <img src={driverDocsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={driverDocs} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/fleet-documents" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/fleet-documents') ? '#F3F8FF' : '#fff',
                                color: isActive('/fleet-documents') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.CORPORATE) && (
                    <Grid2 sx={{backgroundColor: isActive('/corporate') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Corporate"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/corporate'))
                                    ? <img src={corporateAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={corporate} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/corporate" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/corporate') ? '#F3F8FF' : '#fff',
                                color: isActive('/corporate') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.MERCHANTS) && (
                    <Grid2 sx={{backgroundColor: isActive('/merchants') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Merchants"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/merchants'))
                                    ? <img src={corporateAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={corporate} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/merchants" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/merchants') ? '#F3F8FF' : '#fff',
                                color: isActive('/merchants') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.GEOFENCE) && (
                    <Grid2 sx={{backgroundColor: isActive('/geofence') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        {/* {hasPermission(SidebarTabs.GEOFENCE) && ( */}
                            <SubMenu
                                label="Geofence"
                                defaultOpen="true"
                                className="submenu-no-arrow"
                                icon = {
                                    (isActive('/geofence'))
                                        ? <img src={geofenceAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                        : <img src={geofence} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                }
                                component={<Link to="/geofence" />}
                                style={{
                                    paddingLeft:'8px',
                                    borderRadius: '8px',
                                    backgroundColor: isActive('/geofence') ? '#F3F8FF' : '#fff',
                                    color: isActive('/geofence') ? '#1A1E25' : '#83888E',
                                    transition: 'all 0.3s ease',
                                }}
                                >
                            </SubMenu>
                        {/* )} */}
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.CUSTOMZONE) && (
                    <Grid2 sx={{backgroundColor: isActive('/custom-zone') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        {/* {hasPermission(SidebarTabs.SURGEPRICING) && ( */}
                            <SubMenu
                                label="Custom Zone"
                                defaultOpen="true"
                                className="submenu-no-arrow"
                                icon = {
                                    (isActive('/custom-zone'))
                                        ? <img src={customZoneAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                        : <img src={customZoneInact} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                }
                                component={<Link to="/custom-zone" />}
                                style={{
                                    paddingLeft:'8px',
                                    // margin: '0 10px',
                                    borderRadius: '8px',
                                    // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                    backgroundColor: isActive('/custom-zone') ? '#F3F8FF' : '#fff',
                                    color: isActive('/custom-zone') ? '#1A1E25' : '#83888E',
                                    transition: 'all 0.3s ease',
                                    // border: isOpen ? '1px solid #E6F0FF' : 'none'
                                }}
                            >
                            </SubMenu>
                        {/* )} */}
                    </Grid2>
                )}

                {(hasPermission(SidebarTabs.TAXI_CANCELLATION_POLICY) || hasPermission(SidebarTabs.TAXI_CANCELLATION_REASON)) && (
                    <Grid2 sx={{backgroundColor: (isActive('/taxi-cancellation-policy') || isActive('/taxi-cancellation-reason')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                        <SubMenu
                            label="Cancellation"
                            defaultOpen="true"
                            icon = {
                                (isActive('/taxi-cancellation-policy') || isActive('/taxi-cancellation-reason'))
                                    ? <img src={tmsVehicleAct} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={tmsVehicleInact} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: (isActive('/taxi-cancellation-policy') || isActive('/taxi-cancellation-reason')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/taxi-cancellation-policy') || isActive('/taxi-cancellation-reason')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                                {hasPermission(SidebarTabs.TAXI_CANCELLATION_POLICY) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/taxi-cancellation-policy') || isActive('/taxi-cancellation-reason')) && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/taxi-cancellation-policy') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/taxi-cancellation-policy" />}
                                            style={{
                                                backgroundColor: isActive('/taxi-cancellation-policy') ? '#F3F8FF' : '#fff',
                                                color: isActive('/taxi-cancellation-policy') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/taxi-cancellation-policy') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Cancellation Policy
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TAXI_CANCELLATION_REASON) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/taxi-cancellation-reason')) && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/taxi-cancellation-reason') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/taxi-cancellation-reason" />}
                                            style={{
                                                backgroundColor: isActive('/taxi-cancellation-reason') ? '#F3F8FF' : '#fff',
                                                color: isActive('/taxi-cancellation-reason') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/taxi-cancellation-reason') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Cancellation Reasons
                                        </MenuItem>
                                    </Grid2>
                                )}
                            </Grid2>

                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.HOMESCREEN) && (
                    <Grid2 sx={{backgroundColor: (isActive('/homescreen-settings') || isActive('/homeScreen-details')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Dynamic HomeScreen"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/homescreen-settings') || isActive('/homeScreen-details'))
                                    ? <img src={homescreenAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={homescreen} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/homescreen-settings" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: (isActive('/homescreen-settings') || isActive('/homeScreen-details')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/homescreen-settings')|| isActive('/homeScreen-details')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                            >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.ANALYTICS) && (
                    <Grid2 sx={{backgroundColor: (isActive('/analytics')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Analytics"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/analytics'))
                                    ? <img src={analyticsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={analytics} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/analytics" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: (isActive('/analytics')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/analytics')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                            >
                        </SubMenu>
                    </Grid2>
                )}
                {hasPermission(SidebarTabs.CHANGE_DESTINATION) && (
                    <Grid2 sx={{backgroundColor: (isActive('/change-destination')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Change Destination"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/change-destination'))
                                    ? <img src={analyticsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={analytics} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/change-destination" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: (isActive('/change-destination')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/change-destination')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                            >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.PUSHES) && (
                    <Grid2 sx={{backgroundColor: (isActive('/pushes')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Pushes"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/pushes'))
                                    ? <img src={pushes} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={pushesInact} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/pushes" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: (isActive('/pushes')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/pushes')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                            >
                        </SubMenu>
                    </Grid2>
                )}

                {hasPermission(SidebarTabs.TMS_LOCATIONS) && (
                    <Grid2 sx={{backgroundColor: (isActive('/tms-locations')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Locations"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/tms-locations'))
                                    ? <img src={tmsLocation} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={tmsLocationInact} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/tms-locations" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: (isActive('/tms-locations')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/tms-locations')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                            >
                        </SubMenu>
                    </Grid2>
                )}
                {hasPermission(SidebarTabs.MANAGE_CARDS) && (
                    <Grid2 sx={{backgroundColor: isActive('/manage-cards') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                        <SubMenu
                            label="Card and Payments"
                            defaultOpen="true"
                            className="submenu-no-arrow"
                            icon = {
                                (isActive('/manage-cards'))
                                    ? <img src={dashboardActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={dashboardIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/manage-cards" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/manage-cards') ? '#F3F8FF' : '#fff',
                                color: isActive('/manage-cards') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                        </SubMenu>
                    </Grid2>
                )}

                {(hasPermission(SidebarTabs.GENERALSETTINGS) || hasPermission(SidebarTabs.TMS_BOOKING_SETTINGS) || hasPermission(SidebarTabs.CITYSETTINGS) || hasPermission(SidebarTabs.SCHEDULERIDE) || hasPermission(SidebarTabs.MANAGERSETTINGS) || hasPermission(SidebarTabs.OPERATIONALCITIES) || hasPermission(SidebarTabs.REVIEW_SUGGESTIONS) || hasPermission(SidebarTabs.CHAT_SUGGESTIONS) || hasPermission(SidebarTabs.PARCEL_SETTINGS) || hasPermission(SidebarTabs.NO_SHOW_SETTINGS) || hasPermission(SidebarTabs.CORPORATE_SETTINGS) || hasPermission(SidebarTabs.FLEET_MANAGERS)) && (
                    <Grid2 sx={{backgroundColor: (isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/operational-cities') || isActive('/city_settings') || isActive('/general_settings') ||isActive('/tms-booking-settings') ||isActive('/roles_and_permissions') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/parcel-settings') || isActive('/no-show-settings') || isActive('/corporate_settings')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>


                        <SubMenu
                            label="Settings"
                            defaultOpen="true"
                            icon = {
                                (isActive('/roles_and_permissions') || isActive('/settings/schedule-ride') || isActive('/manager_settings') || (isActive('/general_settings')) || (isActive('/city_settings')) || isActive('/operational-cities') || isActive('/tms-booking-settings') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/parcel-settings') || isActive('/no-show-settings') || isActive('/corporate_settings') || isActive('/fleet_managers')) 

                                    ? <img src={settingsIcon} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={settingsInactive} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: (isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/general_settings') || isActive('/city_settings') || isActive('/operational-cities') ||isActive('/tms-booking-settings') ||isActive('/roles_and_permissions') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/parcel-settings') || isActive('/no-show-settings') || isActive('/corporate_settings')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/general_settings') || isActive('/operational-cities') || isActive('/city_settings') ||isActive('/tms-booking-settings') ||isActive('/roles_and_permissions') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/parcel-settings') || isActive('/no-show-settings') || isActive('/corporate_settings')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                                {hasPermission(SidebarTabs.GENERALSETTINGS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/manager_settings') || isActive('/settings/schedule-ride') || isActive('/general_settings') || isActive('/city_settings') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/parcel-settings')) && isOpen ? '#fff' : '#fff',
                                        padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/general_settings') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/general_settings" />}
                                            style={{
                                                backgroundColor: isActive('/general_settings') ? '#F3F8FF' : '#fff',
                                                color: isActive('/general_settings') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/general_settings') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            General Settings
                                        </MenuItem>
                                    </Grid2>
                                )}
                                                                {hasPermission(SidebarTabs.CORPORATE_SETTINGS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') ||isActive('/operational-cities') || isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/corporate_settings')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/corporate_settings') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/corporate_settings" />}
                                            style={{
                                                backgroundColor: isActive('/corporate_settings') ? '#F3F8FF' : '#fff',
                                                color: isActive('/corporate_settings') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/corporate_settings') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Corporate Settings
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.TMS_BOOKING_SETTINGS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/manager_settings') || isActive('/settings/schedule-ride') || isActive('/general_settings') || isActive('/city_settings') || isActive('/tms-booking-settings') || isActive('/review_suggestions') || isActive('/chat-suggestions')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/tms-booking-settings') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/tms-booking-settings" />}
                                            style={{
                                                backgroundColor: isActive('/tms-booking-settings') ? '#F3F8FF' : '#fff',
                                                color: isActive('/tms-booking-settings') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/tms-booking-settings') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Booking Settings
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.CITYSETTINGS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/manager_settings') || isActive('/settings/schedule-ride') || isActive('/general_settings') || isActive('/city_settings') || isActive('/review_suggestions') || isActive('/chat-suggestions')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/city_settings') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/city_settings" />}
                                            style={{
                                                backgroundColor: isActive('/city_settings') ? '#F3F8FF' : '#fff',
                                                color: isActive('/city_settings') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/city_settings') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            City Settings
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.SCHEDULERIDE) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/operational-cities') || isActive('/review_suggestions') || isActive('/chat-suggestions')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                            sx={{ color: (isActive('/settings/schedule-ride')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                        <MenuItem className='subItems' component={<Link to="/settings/schedule-ride" />}
                                            style={{
                                                backgroundColor: (isActive('/settings/schedule-ride')) ? '#F3F8FF' : '#fff', 
                                                color: (isActive('/settings/schedule-ride')) ? '#0065FF' : '#83888E',
                                                borderRadius: (isActive('/settings/schedule-ride')) ? '8px':'0', paddingLeft:'20px',
                                            }}>
                                            
                                            Schedule Ride Settings
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.MANAGERSETTINGS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/manager_settings') || isActive('/settings/schedule-ride') || isActive('/review_suggestions') || isActive('/chat-suggestions')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/manager_settings') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/manager_settings" />}
                                            style={{
                                                backgroundColor: isActive('/manager_settings') ? '#F3F8FF' : '#fff',
                                                color: isActive('/manager_settings') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/manager_settings') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Manager Settings
                                        </MenuItem>
                                    </Grid2>
                                )}
                                {hasPermission(SidebarTabs.FLEET_MANAGERS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/manager_settings') || isActive('/fleet-managers') || isActive('/settings/schedule-ride') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/fleet_managers')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/fleet-managers') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/fleet-managers" />}
                                            style={{
                                                backgroundColor: isActive('/fleet-managers') ? '#F3F8FF' : '#fff',
                                                color: isActive('/fleet-managers') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/fleet-managers') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Fleet Managers
                                        </MenuItem>
                                    </Grid2>
                                )}
                                {hasPermission(SidebarTabs.FLEET_SETTINGS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/manager_settings') || isActive('/fleet-managers') || isActive('/settings/schedule-ride') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/fleet_managers') || isActive('/fleet-settings')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/fleet-settings') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/fleet-settings" />}
                                            style={{
                                                backgroundColor: isActive('/fleet-settings') ? '#F3F8FF' : '#fff',
                                                color: isActive('/fleet-settings') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/fleet-settings') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Fleet Settings
                                        </MenuItem>
                                    </Grid2>
                                )}
                                {hasPermission(SidebarTabs.CORPORATE_MANAGAERS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/manager_settings') || isActive('/settings/schedule-ride') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/corporate-manager')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/corporate-manager') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/corporate-manager" />}
                                            style={{
                                                backgroundColor: isActive('/corporate-manager') ? '#F3F8FF' : '#fff',
                                                color: isActive('/corporate-manager') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/corporate-manager') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Corporate Managers
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.MERCHANT_MANAGERS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/manager_settings') || isActive('/settings/schedule-ride') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/corporate-manager') || isActive('/merchant-managers')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/merchant-managers') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/merchant-managers" />}
                                            style={{
                                                backgroundColor: isActive('/merchant-managers') ? '#F3F8FF' : '#fff',
                                                color: isActive('/merchant-managers') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/merchant-managers') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Merchant Managers
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.ROLES_AND_PERMISSIONS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') || isActive('/settings/schedule-ride') || isActive('/general_settings') || isActive('/city_settings') || isActive('/tms-booking-settings') || isActive('/review_suggestions') || isActive('/chat-suggestions')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/roles_and_permissions') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/roles_and_permissions" />}
                                            style={{
                                                backgroundColor: isActive('/roles_and_permissions') ? '#F3F8FF' : '#fff',
                                                color: isActive('/roles_and_permissions') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/roles_and_permissions') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Roles and Permissions
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.OPERATIONALCITIES) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') ||isActive('/operational-cities') || isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/review_suggestions') || isActive('/chat-suggestions')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/operational-cities') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/operational-cities" />}
                                            style={{
                                                backgroundColor: isActive('/operational-cities') ? '#F3F8FF' : '#fff',
                                                color: isActive('/operational-cities') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/operational-cities') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Operational Cities
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.REVIEW_SUGGESTIONS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') ||isActive('/operational-cities') || isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/corporate_settings')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/review_suggestions') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/review_suggestions" />}
                                            style={{
                                                backgroundColor: isActive('/review_suggestions') ? '#F3F8FF' : '#fff',
                                                color: isActive('/review_suggestions') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/review_suggestions') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Review Suggestions
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.CHAT_SUGGESTIONS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') ||isActive('/operational-cities') || isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/corporate_settings')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/chat-suggestions') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/chat-suggestions" />}
                                            style={{
                                                backgroundColor: isActive('/chat-suggestions') ? '#F3F8FF' : '#fff',
                                                color: isActive('/chat-suggestions') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/chat-suggestions') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Chat Suggestions
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.PARCEL_SETTINGS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') ||isActive('/operational-cities') || isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/parcel-settings')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/parcel-settings') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/parcel-settings" />}
                                            style={{
                                                backgroundColor: isActive('/parcel-settings') ? '#F3F8FF' : '#fff',
                                                color: isActive('/parcel-settings') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/parcel-settings') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            Parcel Settings
                                        </MenuItem>
                                    </Grid2>
                                )}

                                {hasPermission(SidebarTabs.NO_SHOW_SETTINGS) && (
                                    <Grid2 sx={{
                                        display: 'flex', alignItems:'center',
                                        backgroundColor: (isActive('/roles_and_permissions') ||isActive('/operational-cities') || isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/review_suggestions') || isActive('/chat-suggestions') || isActive('/no-show-settings')) && isOpen ? '#fff' : '#fff',
                                        padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                    }}>
                                        <FiberManualRecordIcon 
                                                sx={{ 
                                                    color: isActive('/no-show-settings') ? '#0065FF' : '#83888E', 
                                                    marginRight: '8px',
                                                    width:'16px'
                                                }} 
                                            />
                                        <MenuItem className='subItems' component={<Link to="/no-show-settings" />}
                                            style={{
                                                backgroundColor: isActive('/no-show-settings') ? '#F3F8FF' : '#fff',
                                                color: isActive('/no-show-settings') ? '#0065FF' : '#83888E',
                                                borderRadius: isActive('/no-show-settings') ? '8px':'0',
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            No Show Settings
                                        </MenuItem>
                                    </Grid2>
                                )}
                            </Grid2>

                        </SubMenu>
                    </Grid2>
                )}
                
            </Menu>
        </Sidebar>
    );
};

export default Sidemenu;
